import { type ReactElement, type ReactNode } from 'react';

import { type Permission } from '@irl/types';

import { usePermissionState } from '@/hooks/usePermissions';

interface PermissionGateProps {
  permission: Permission;
  chatId?: string;
  fallback?: ReactNode;
  loading?: ReactNode;
  children: ReactNode;
}

export function PermissionGate({
  permission,
  chatId,
  fallback = null,
  loading = null,
  children,
}: PermissionGateProps): ReactElement | null {
  const { allowed, isLoading } = usePermissionState(permission, chatId);

  if (isLoading) {
    return <>{loading}</>;
  }

  if (!allowed) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
